import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "onClick", "aria-label"];
import React from "react";
import { StyledActionButton } from "../styled/ActionButton";
export var ModalActionButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var content = _ref.content,
    onClick = _ref.onClick,
    ariaLabel = _ref["aria-label"],
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledActionButton, _extends({
    onClick: onClick,
    appearance: "borderless",
    type: "button",
    "aria-label": ariaLabel,
    ref: ref
  }, props), content);
});
ModalActionButton.displayName = "ModalActionButton";
//# sourceMappingURL=ModalActionButton.js.map